import * as yup from 'yup';
import { NOTIFICATION_TYPE } from "@/utils/constants";
export const notificationSchema = yup.object({
  code: yup.string().required('Código es requerido'),
  subject: yup.string().required('Asunto es requerido'),
  type: yup.number().nullable().required('Tipo es requerido'),
  fileCover: yup
  .mixed()
  .nullable()
  .when('multimedia', {
    is: (multimedia:any) => !multimedia, // if multimedia is empty
    then: (schema) => schema
      .required('Imagen es requerida')
      .test('fileSize', 'La imagen no debe pesar más de 2MB', (value: any) => {
        if (!value) return false;
        return value.size <= 2 * 1024 * 1024; // 2MB max
      })
      .test('fileType', 'Formato del archivo no es válido', (value: any) => {
        if (!value) return false;
        const supportedFormats = ['image/jpg', 'image/jpeg', 'image/png'];
        return supportedFormats.includes(value.type);
      }),
    otherwise: (schema) => schema.notRequired(),
  }),
  htmlContent: yup.string().when('type', {
    is: NOTIFICATION_TYPE.EMAIL,
    then: (schema) =>
      schema
        .transform((value) => {
          if (!value) return "";
  
          const temp = document.createElement("div");
          temp.innerHTML = value;
          return temp.textContent?.trim() || "";
        })
        .required('Contenido es requerido'),
    otherwise: (schema) => schema.notRequired()
  }),
  
  txtContent: yup.string().when('type', {
    is: (type: any) => type !== NOTIFICATION_TYPE.EMAIL,
    then: (schema) =>
      schema
        .trim()
        .required('Contenido es requerido'),
    otherwise: (schema) => schema.notRequired()
  }),
  icon: yup.string().when('type', {
    is: (type: any) => type !== NOTIFICATION_TYPE.EMAIL,
    then: (schema) =>
      schema
        .trim()
        .required('Icono es requerido'),
    otherwise: (schema) => schema.notRequired()
  }),
});